module.exports = __webpack_public_path__ + "img/image00014-min.22606db2.jpeg";